<form
  [formGroup]="pipStateSummary"
  #summaryContainer
>
  <axis-card id="summaryCard">
    <axis-card-heading class="border-condensed">
      <axis-card-heading-body>
        @if (!isStatePageEmptyScoped) {
          <h1 class="axis-h3 _mb-medium">
            {{ stateSummaryData?.title }}
          </h1>
        }
        @if (!isStatePageEmptyScoped) {
          <p>{{ stateSummaryData?.review }}</p>
          <p class="_text-bold">{{ stateSummaryData?.note }}</p>
        }
      </axis-card-heading-body>
    </axis-card-heading>
    <axis-card-body>
      @if (isStatePageEmptyScoped) {
        <div class="initial-empty-container">
          <img
            alt=""
            class="axis-img-responsive _mlr-auto"
            src="assets/images/messages/no-manuscript.svg"
            loading="lazy"
          />
          <p>Continue to Outstanding State Selection</p>
        </div>
      }
      <ng-template #stateComponent></ng-template>
    </axis-card-body>
  </axis-card>
  @if (!isStatePageEmptyScoped && !isBroker) {
    <axis-card>
      <axis-card-body>
        <h2 class="axis-h3">
          {{ stateSummaryData?.confirmTitle }}
        </h2>
        <div
          class="axis-form-group has-axis-required"
          [ngClass]="{
            'has-axis-error':
              pipStateSummary.get('pipConfirmStateDis')?.invalid && pipStateSummary.get('pipConfirmStateDis').touched,
          }"
        >
          <axis-checkbox
            [heading]="stateSummaryData?.confirmLabel"
            formControlName="pipConfirmStateDis"
            [required]="true"
            class="kind-custom"
            ><span
              aria-hidden="true"
              class="axis-required-indicator"
              >*</span
            >
          </axis-checkbox>
          @if (
            pipStateSummary.get("pipConfirmStateDis")?.invalid && pipStateSummary.get("pipConfirmStateDis").touched
          ) {
            <div class="axis-error-block">Please select check box.</div>
          }
        </div>
      </axis-card-body>
    </axis-card>
  }
  <div class="axis-btn-wrapper">
    <div class="axis-btn-wrapper-left">
      <button
        axis-button
        class="kind-secondary"
        (click)="onBack()"
      >
        <span class="axis-btn-icon-text">Back</span>
      </button>
    </div>
    <div class="axis-btn-wrapper-right">
      <button
        axis-button
        class="kind-primary"
        (click)="onContinue()"
      >
        <span class="axis-btn-icon-text">Continue</span>
      </button>
    </div>
  </div>
</form>
